import { render, staticRenderFns } from "./CaseDIY.vue?vue&type=template&id=709f75c2&scoped=true&"
import script from "./CaseDIY.vue?vue&type=script&lang=js&"
export * from "./CaseDIY.vue?vue&type=script&lang=js&"
import style0 from "./CaseDIY.vue?vue&type=style&index=0&id=709f75c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f75c2",
  null
  
)

export default component.exports